module.exports = __webpack_public_path__ + "static/media/salesforce.435e149d.png";